module.exports = __webpack_public_path__ + "img/good-session-9.734522e1.png";